/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedShellRouteImport } from './routes/_authenticated/_shell'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthLandingRouteImport } from './routes/auth/landing'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as AuthenticatedShellIndexRouteImport } from './routes/_authenticated/_shell/index'
import { Route as AuthenticatedShellSplatRouteImport } from './routes/_authenticated/_shell/$'
import { Route as AuthenticatedShellActivityRouteImport } from './routes/_authenticated/_shell/activity'
import { Route as AuthenticatedShellCardsRouteImport } from './routes/_authenticated/_shell/cards'
import { Route as AuthenticatedShellExpensesRouteImport } from './routes/_authenticated/_shell/expenses'
import { Route as AuthenticatedShellIncomeRouteImport } from './routes/_authenticated/_shell/income'
import { Route as AuthenticatedShellInvestmentsRouteImport } from './routes/_authenticated/_shell/investments'
import { Route as AuthenticatedShellPropertiesRouteImport } from './routes/_authenticated/_shell/properties'
import { Route as AuthenticatedShellSavingsRouteImport } from './routes/_authenticated/_shell/savings'
import { Route as AuthenticatedShellSettingsRouteImport } from './routes/_authenticated/_shell/settings'
import { Route as AuthenticatedShellVehiclesRouteImport } from './routes/_authenticated/_shell/vehicles'
import { Route as AuthenticatedShellInvestmentsStockIdRouteImport } from './routes/_authenticated/_shell/investments_.$stockId'
import { Route as AuthenticatedShellPropertiesPropertyIdRouteImport } from './routes/_authenticated/_shell/properties_.$propertyId'
import { Route as AuthenticatedShellSavingsAccountIdRouteImport } from './routes/_authenticated/_shell/savings_.$accountId'
import { Route as AuthenticatedShellSettingsHouseholdRouteImport } from './routes/_authenticated/_shell/settings_.household'
import { Route as AuthenticatedShellSettingsProfileRouteImport } from './routes/_authenticated/_shell/settings_.profile'
import { Route as AuthenticatedShellVehiclesVehicleIdRouteImport } from './routes/_authenticated/_shell/vehicles_.$vehicleId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellRoute = AuthenticatedShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthLandingRoute = AuthLandingRouteImport.update({
  id: '/auth/landing',
  path: '/auth/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellIndexRoute = AuthenticatedShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellSplatRoute = AuthenticatedShellSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellActivityRoute =
  AuthenticatedShellActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCardsRoute = AuthenticatedShellCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellExpensesRoute =
  AuthenticatedShellExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellIncomeRoute =
  AuthenticatedShellIncomeRouteImport.update({
    id: '/income',
    path: '/income',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellInvestmentsRoute =
  AuthenticatedShellInvestmentsRouteImport.update({
    id: '/investments',
    path: '/investments',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPropertiesRoute =
  AuthenticatedShellPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSavingsRoute =
  AuthenticatedShellSavingsRouteImport.update({
    id: '/savings',
    path: '/savings',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSettingsRoute =
  AuthenticatedShellSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellVehiclesRoute =
  AuthenticatedShellVehiclesRouteImport.update({
    id: '/vehicles',
    path: '/vehicles',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellInvestmentsStockIdRoute =
  AuthenticatedShellInvestmentsStockIdRouteImport.update({
    id: '/investments_/$stockId',
    path: '/investments/$stockId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPropertiesPropertyIdRoute =
  AuthenticatedShellPropertiesPropertyIdRouteImport.update({
    id: '/properties_/$propertyId',
    path: '/properties/$propertyId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSavingsAccountIdRoute =
  AuthenticatedShellSavingsAccountIdRouteImport.update({
    id: '/savings_/$accountId',
    path: '/savings/$accountId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSettingsHouseholdRoute =
  AuthenticatedShellSettingsHouseholdRouteImport.update({
    id: '/settings_/household',
    path: '/settings/household',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSettingsProfileRoute =
  AuthenticatedShellSettingsProfileRouteImport.update({
    id: '/settings_/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellVehiclesVehicleIdRoute =
  AuthenticatedShellVehiclesVehicleIdRouteImport.update({
    id: '/vehicles_/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedShellIndexRoute
  '/sign-in': typeof SignInRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/auth/landing': typeof AuthLandingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$': typeof AuthenticatedShellSplatRoute
  '/activity': typeof AuthenticatedShellActivityRoute
  '/cards': typeof AuthenticatedShellCardsRoute
  '/expenses': typeof AuthenticatedShellExpensesRoute
  '/income': typeof AuthenticatedShellIncomeRoute
  '/investments': typeof AuthenticatedShellInvestmentsRoute
  '/properties': typeof AuthenticatedShellPropertiesRoute
  '/savings': typeof AuthenticatedShellSavingsRoute
  '/settings': typeof AuthenticatedShellSettingsRoute
  '/vehicles': typeof AuthenticatedShellVehiclesRoute
  '/investments/$stockId': typeof AuthenticatedShellInvestmentsStockIdRoute
  '/properties/$propertyId': typeof AuthenticatedShellPropertiesPropertyIdRoute
  '/savings/$accountId': typeof AuthenticatedShellSavingsAccountIdRoute
  '/settings/household': typeof AuthenticatedShellSettingsHouseholdRoute
  '/settings/profile': typeof AuthenticatedShellSettingsProfileRoute
  '/vehicles/$vehicleId': typeof AuthenticatedShellVehiclesVehicleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedShellIndexRoute
  '/sign-in': typeof SignInRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/auth/landing': typeof AuthLandingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$': typeof AuthenticatedShellSplatRoute
  '/activity': typeof AuthenticatedShellActivityRoute
  '/cards': typeof AuthenticatedShellCardsRoute
  '/expenses': typeof AuthenticatedShellExpensesRoute
  '/income': typeof AuthenticatedShellIncomeRoute
  '/investments': typeof AuthenticatedShellInvestmentsRoute
  '/properties': typeof AuthenticatedShellPropertiesRoute
  '/savings': typeof AuthenticatedShellSavingsRoute
  '/settings': typeof AuthenticatedShellSettingsRoute
  '/vehicles': typeof AuthenticatedShellVehiclesRoute
  '/investments/$stockId': typeof AuthenticatedShellInvestmentsStockIdRoute
  '/properties/$propertyId': typeof AuthenticatedShellPropertiesPropertyIdRoute
  '/savings/$accountId': typeof AuthenticatedShellSavingsAccountIdRoute
  '/settings/household': typeof AuthenticatedShellSettingsHouseholdRoute
  '/settings/profile': typeof AuthenticatedShellSettingsProfileRoute
  '/vehicles/$vehicleId': typeof AuthenticatedShellVehiclesVehicleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/_shell': typeof AuthenticatedShellRouteWithChildren
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/auth/landing': typeof AuthLandingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_authenticated/_shell/$': typeof AuthenticatedShellSplatRoute
  '/_authenticated/_shell/activity': typeof AuthenticatedShellActivityRoute
  '/_authenticated/_shell/cards': typeof AuthenticatedShellCardsRoute
  '/_authenticated/_shell/expenses': typeof AuthenticatedShellExpensesRoute
  '/_authenticated/_shell/income': typeof AuthenticatedShellIncomeRoute
  '/_authenticated/_shell/investments': typeof AuthenticatedShellInvestmentsRoute
  '/_authenticated/_shell/properties': typeof AuthenticatedShellPropertiesRoute
  '/_authenticated/_shell/savings': typeof AuthenticatedShellSavingsRoute
  '/_authenticated/_shell/settings': typeof AuthenticatedShellSettingsRoute
  '/_authenticated/_shell/vehicles': typeof AuthenticatedShellVehiclesRoute
  '/_authenticated/_shell/': typeof AuthenticatedShellIndexRoute
  '/_authenticated/_shell/investments_/$stockId': typeof AuthenticatedShellInvestmentsStockIdRoute
  '/_authenticated/_shell/properties_/$propertyId': typeof AuthenticatedShellPropertiesPropertyIdRoute
  '/_authenticated/_shell/savings_/$accountId': typeof AuthenticatedShellSavingsAccountIdRoute
  '/_authenticated/_shell/settings_/household': typeof AuthenticatedShellSettingsHouseholdRoute
  '/_authenticated/_shell/settings_/profile': typeof AuthenticatedShellSettingsProfileRoute
  '/_authenticated/_shell/vehicles_/$vehicleId': typeof AuthenticatedShellVehiclesVehicleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/onboarding'
    | '/auth/landing'
    | '/invite/$token'
    | '/$'
    | '/activity'
    | '/cards'
    | '/expenses'
    | '/income'
    | '/investments'
    | '/properties'
    | '/savings'
    | '/settings'
    | '/vehicles'
    | '/investments/$stockId'
    | '/properties/$propertyId'
    | '/savings/$accountId'
    | '/settings/household'
    | '/settings/profile'
    | '/vehicles/$vehicleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/onboarding'
    | '/auth/landing'
    | '/invite/$token'
    | '/$'
    | '/activity'
    | '/cards'
    | '/expenses'
    | '/income'
    | '/investments'
    | '/properties'
    | '/savings'
    | '/settings'
    | '/vehicles'
    | '/investments/$stockId'
    | '/properties/$propertyId'
    | '/savings/$accountId'
    | '/settings/household'
    | '/settings/profile'
    | '/vehicles/$vehicleId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/_shell'
    | '/_authenticated/onboarding'
    | '/auth/landing'
    | '/invite/$token'
    | '/_authenticated/_shell/$'
    | '/_authenticated/_shell/activity'
    | '/_authenticated/_shell/cards'
    | '/_authenticated/_shell/expenses'
    | '/_authenticated/_shell/income'
    | '/_authenticated/_shell/investments'
    | '/_authenticated/_shell/properties'
    | '/_authenticated/_shell/savings'
    | '/_authenticated/_shell/settings'
    | '/_authenticated/_shell/vehicles'
    | '/_authenticated/_shell/'
    | '/_authenticated/_shell/investments_/$stockId'
    | '/_authenticated/_shell/properties_/$propertyId'
    | '/_authenticated/_shell/savings_/$accountId'
    | '/_authenticated/_shell/settings_/household'
    | '/_authenticated/_shell/settings_/profile'
    | '/_authenticated/_shell/vehicles_/$vehicleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
  AuthLandingRoute: typeof AuthLandingRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell': {
      id: '/_authenticated/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/landing': {
      id: '/auth/landing'
      path: '/auth/landing'
      fullPath: '/auth/landing'
      preLoaderRoute: typeof AuthLandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell/': {
      id: '/_authenticated/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellIndexRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/$': {
      id: '/_authenticated/_shell/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedShellSplatRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/activity': {
      id: '/_authenticated/_shell/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedShellActivityRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/cards': {
      id: '/_authenticated/_shell/cards'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof AuthenticatedShellCardsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/expenses': {
      id: '/_authenticated/_shell/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AuthenticatedShellExpensesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/income': {
      id: '/_authenticated/_shell/income'
      path: '/income'
      fullPath: '/income'
      preLoaderRoute: typeof AuthenticatedShellIncomeRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/investments': {
      id: '/_authenticated/_shell/investments'
      path: '/investments'
      fullPath: '/investments'
      preLoaderRoute: typeof AuthenticatedShellInvestmentsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/properties': {
      id: '/_authenticated/_shell/properties'
      path: '/properties'
      fullPath: '/properties'
      preLoaderRoute: typeof AuthenticatedShellPropertiesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/savings': {
      id: '/_authenticated/_shell/savings'
      path: '/savings'
      fullPath: '/savings'
      preLoaderRoute: typeof AuthenticatedShellSavingsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/settings': {
      id: '/_authenticated/_shell/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedShellSettingsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/vehicles': {
      id: '/_authenticated/_shell/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof AuthenticatedShellVehiclesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/investments_/$stockId': {
      id: '/_authenticated/_shell/investments_/$stockId'
      path: '/investments/$stockId'
      fullPath: '/investments/$stockId'
      preLoaderRoute: typeof AuthenticatedShellInvestmentsStockIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/properties_/$propertyId': {
      id: '/_authenticated/_shell/properties_/$propertyId'
      path: '/properties/$propertyId'
      fullPath: '/properties/$propertyId'
      preLoaderRoute: typeof AuthenticatedShellPropertiesPropertyIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/savings_/$accountId': {
      id: '/_authenticated/_shell/savings_/$accountId'
      path: '/savings/$accountId'
      fullPath: '/savings/$accountId'
      preLoaderRoute: typeof AuthenticatedShellSavingsAccountIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/settings_/household': {
      id: '/_authenticated/_shell/settings_/household'
      path: '/settings/household'
      fullPath: '/settings/household'
      preLoaderRoute: typeof AuthenticatedShellSettingsHouseholdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/settings_/profile': {
      id: '/_authenticated/_shell/settings_/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedShellSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/vehicles_/$vehicleId': {
      id: '/_authenticated/_shell/vehicles_/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof AuthenticatedShellVehiclesVehicleIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
  }
}

interface AuthenticatedShellRouteChildren {
  AuthenticatedShellSplatRoute: typeof AuthenticatedShellSplatRoute
  AuthenticatedShellActivityRoute: typeof AuthenticatedShellActivityRoute
  AuthenticatedShellCardsRoute: typeof AuthenticatedShellCardsRoute
  AuthenticatedShellExpensesRoute: typeof AuthenticatedShellExpensesRoute
  AuthenticatedShellIncomeRoute: typeof AuthenticatedShellIncomeRoute
  AuthenticatedShellInvestmentsRoute: typeof AuthenticatedShellInvestmentsRoute
  AuthenticatedShellPropertiesRoute: typeof AuthenticatedShellPropertiesRoute
  AuthenticatedShellSavingsRoute: typeof AuthenticatedShellSavingsRoute
  AuthenticatedShellSettingsRoute: typeof AuthenticatedShellSettingsRoute
  AuthenticatedShellVehiclesRoute: typeof AuthenticatedShellVehiclesRoute
  AuthenticatedShellIndexRoute: typeof AuthenticatedShellIndexRoute
  AuthenticatedShellInvestmentsStockIdRoute: typeof AuthenticatedShellInvestmentsStockIdRoute
  AuthenticatedShellPropertiesPropertyIdRoute: typeof AuthenticatedShellPropertiesPropertyIdRoute
  AuthenticatedShellSavingsAccountIdRoute: typeof AuthenticatedShellSavingsAccountIdRoute
  AuthenticatedShellSettingsHouseholdRoute: typeof AuthenticatedShellSettingsHouseholdRoute
  AuthenticatedShellSettingsProfileRoute: typeof AuthenticatedShellSettingsProfileRoute
  AuthenticatedShellVehiclesVehicleIdRoute: typeof AuthenticatedShellVehiclesVehicleIdRoute
}

const AuthenticatedShellRouteChildren: AuthenticatedShellRouteChildren = {
  AuthenticatedShellSplatRoute: AuthenticatedShellSplatRoute,
  AuthenticatedShellActivityRoute: AuthenticatedShellActivityRoute,
  AuthenticatedShellCardsRoute: AuthenticatedShellCardsRoute,
  AuthenticatedShellExpensesRoute: AuthenticatedShellExpensesRoute,
  AuthenticatedShellIncomeRoute: AuthenticatedShellIncomeRoute,
  AuthenticatedShellInvestmentsRoute: AuthenticatedShellInvestmentsRoute,
  AuthenticatedShellPropertiesRoute: AuthenticatedShellPropertiesRoute,
  AuthenticatedShellSavingsRoute: AuthenticatedShellSavingsRoute,
  AuthenticatedShellSettingsRoute: AuthenticatedShellSettingsRoute,
  AuthenticatedShellVehiclesRoute: AuthenticatedShellVehiclesRoute,
  AuthenticatedShellIndexRoute: AuthenticatedShellIndexRoute,
  AuthenticatedShellInvestmentsStockIdRoute:
    AuthenticatedShellInvestmentsStockIdRoute,
  AuthenticatedShellPropertiesPropertyIdRoute:
    AuthenticatedShellPropertiesPropertyIdRoute,
  AuthenticatedShellSavingsAccountIdRoute:
    AuthenticatedShellSavingsAccountIdRoute,
  AuthenticatedShellSettingsHouseholdRoute:
    AuthenticatedShellSettingsHouseholdRoute,
  AuthenticatedShellSettingsProfileRoute:
    AuthenticatedShellSettingsProfileRoute,
  AuthenticatedShellVehiclesVehicleIdRoute:
    AuthenticatedShellVehiclesVehicleIdRoute,
}

const AuthenticatedShellRouteWithChildren =
  AuthenticatedShellRoute._addFileChildren(AuthenticatedShellRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedShellRoute: typeof AuthenticatedShellRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedShellRoute: AuthenticatedShellRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
  AuthLandingRoute: AuthLandingRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
